import { EQuestionActionsTypes } from '@cian/frontend-request-form-widget';
import { EFormFieldsNames, EQuestionCodes, EStepCodes } from '../../../../types/requestForm';
import { createFields } from '../utils/createFields';
import { createValidation } from '../utils/createValidation';
import { SEND_FEEDBACK_BUTTON_TEXT } from '../../../../constants/requestForm/buttonText';
import { createField } from '../utils/createField';
var FIELDS = [EFormFieldsNames.Name, EFormFieldsNames.Phone, EFormFieldsNames.Email, createField(EFormFieldsNames.Message, {
  label: 'Сообщите, если у вас другой вопрос по жалобам',
  required: false,
  description: ''
}), EFormFieldsNames.Files, EFormFieldsNames.PrivacyPolicyAccepted];
export var OFFER_COMPLAINT_FINAL_STEP = {
  code: EStepCodes.OfferComplaintFinal,
  question: {
    code: EQuestionCodes.OfferComplaintFinal,
    title: 'Вопрос по жалобе на объявление',
    fields: createFields(FIELDS),
    validation: createValidation(FIELDS),
    actions: [{
      type: EQuestionActionsTypes.NextQ,
      text: SEND_FEEDBACK_BUTTON_TEXT
    }]
  },
  nextStep: [{
    conditions: [],
    nextStepCode: null
  }]
};